import React from "react"
import { DayWrap } from "./styled"
import dayjs from "dayjs"

const Day = ({
  onChange,
  day,
  value,
  month,
  minDate,
  maxDate,
  noFuture,
  noPast,
  noToday,
}) => (
  <DayWrap
    onClick={() => onChange(day.format("YYYY-MM-DD"))}
    blocked={
      (minDate && day.isBefore(minDate)) ||
      (maxDate && day.isAfter(maxDate)) ||
      (noFuture && day.isAfter(dayjs())) ||
      (noPast &&
        (day.isSame(dayjs(), "day") || day.isBefore(dayjs(), "day"))) ||
      (noToday && day.isSame(dayjs(), "day"))
    }
    active={value && day.diff(dayjs(value).startOf("day"), "days") === 0}
    today={day.diff(dayjs().startOf("day"), "days") === 0}
    outside={day.startOf("month").diff(month.startOf("month"), "months") !== 0}
  >
    {day.format("D")}
  </DayWrap>
)

export default Day
